import Vue from "vue";

import globals from "~/mixins.js/global.js";
import checkout from "~/mixins.js/checkout.js";
import recaptchaMixin from '../mixins.js/recaptcha'

if (!Vue.__my_mixin__) {
	Vue.__my_mixin__ = true
	Vue.mixin(globals);
	Vue.mixin(checkout);
	Vue.mixin(recaptchaMixin);
}
